// extracted by mini-css-extract-plugin
module.exports = {"pagination":"style_pagination__PutZ4","active":"style_active__1Yx5y","hidden":"style_hidden__Xxduh","dots":"style_dots__ZQ_u0"};